import React from "react";

const ContactCard = ({ contact }) => {
  return (
    <div className="contact-row">
      <span id="child1">{contact?.username}</span>
      <span id="child2">{contact?.phone}</span>
      <span id="child3">{contact?.email}</span>
    </div>
  );
};

export default ContactCard;
